import { type ReactNode } from 'react';

/**
 * `ContagemVitalicia` (DESIGN-FOUNDATION §6.5) — nível 0: **não é card e não é
 * KPI tile**. Uma linha sobre o fundo: o número e a frase lado a lado, alinhados
 * pela baseline, `12px` de gap. `total = 0` → o bloco não existe (o oposto de
 * endowed progress). `total = 1` → singular.
 *
 * O número nunca encolhe (`shrink-0`) — é a peça grande da leitura à distância
 * (§0). Em telas estreitas (360-390px) a frase é o dobro do que cabe numa linha
 * ao lado de um número de 28px; em vez de deixar o navegador quebrar numa
 * palavra órfã, `text-wrap: balance` reparte as linhas restantes de forma
 * equilibrada — ainda uma frase corrida ao lado do número, nunca dois blocos
 * empilhados.
 *
 * Usa `tipo-display` (28px), não `tipo-numero` (34px, DESIGN-FOUNDATION §2.3):
 * a Home já tem a placa do código (40px) e o nome do próximo brinde na régua
 * (28px) competindo por peso D-DIN — três números grandes no mesmo quadro era
 * demais (auditoria de densidade P3).
 */
export function ContagemVitalicia({ total }: { total: number }): ReactNode {
  if (total <= 0) return null;
  return (
    <p className="flex items-baseline gap-3">
      <span className="tipo-display shrink-0 text-tinta-forte">{total}</span>
      <span className="tipo-corpo text-tinta-2 [text-wrap:balance]">
        {total === 1
          ? 'amigo já fez um serviço com o seu código.'
          : 'amigos já fizeram um serviço com o seu código.'}
      </span>
    </p>
  );
}
